exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-modal-without-primary .modal__text__title[data-v-5e6d17ab] {\n  white-space: pre-wrap;\n  margin-bottom: 0;\n}\n.text-modal-without-primary .modal__btn--cancel[data-v-5e6d17ab] {\n  padding-top: 0;\n}\n", ""]);
